<template>
  <v-row class="ma-0 pa-0">
    <v-col
      v-for="field in fieldsByType"
      :key="field.key"
      class="py-0"
      cols="12"
      :lg="oneline ? 12 : 4"
      :md="oneline ? 12 : 6"
      :xl="oneline ? 12 : 4"
    >
      <field-group
        v-bind="field.meta"
        :label="field.info.name"
        :layer="layer"
        :readonly="field.readonly || readonly"
        :required="field.required"
        :typeInput="field.typeInput"
        :value="getValueForField(field)"
        @input="setValueForField(field, $event)"
      >
      </field-group>
    </v-col>
    <slot />
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    readonly: Boolean,
    oneline: Boolean,
    form: { type: Object, required: true },
    layer: { type: Object },
  },
  data() {
    return {}
  },
  computed: {
    fieldsByType() {
      return this.form.fieldsByType
    },
  },
  methods: {
    getValueForField(field) {
      return this.form.getValueForField(field)
    },
    setValueForField(field, value) {
      this.form.setValueForField(field, value)
      this.$forceUpdate()
    },
  },
}
</script>

<style scoped>
.label-name {
  flex-basis: 100px;
}
</style>
